import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const { components } = Vue.options

const routes = [
  { path: '/', component: components.RouteHome, name: 'home' },
  { path: '/artist/:artist', components: { default: components.RouteHome, overlay: components.RouteArtist }, name: 'homeArtist' },
  { path: '/atlas', component: components.RouteAtlas, name: 'atlas' },
  { path: '/atlas/artist/:artist', components: { default: components.RouteAtlas, overlay: components.RouteArtist }, name: 'atlasArtist' },
  { path: '/program', component: components.RouteProgram, name: 'program' },
  { path: '/program/artist/:artist', components: { default: components.RouteProgram, overlay: components.RouteArtist }, name: 'programArtist' },
  { path: '/about', component: components.RouteAbout, name: 'about' },
  { path: '/about/artist/:artist', components: { default: components.RouteAbout, overlay: components.RouteArtist }, name: 'aboutArtist' },
  { path: '/bulletin', component: components.RouteBulletin, name: 'bulletin' },
  { path: '/bulletin/artist/:artist', components: { default: components.RouteBulletin, overlay: components.RouteArtist }, name: 'bulletinArtist' },
  { path: '/tags', component: components.RouteTags, name: 'tags' },
  { path: '/tags/artist/:artist', components: { default: components.RouteTags, overlay: components.RouteArtist }, name: 'tagsArtist' },
  { path: '*', component: components.RouteNotFound, name: 'notFound' },
]

const router = new VueRouter({
  routes,
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    const isOverlay = route => route.matched.some(record => record.name.match(/Artist/))

    if(!isOverlay(to) && !isOverlay(from)) return { x: 0, y: 0 }
  }
})

export default router


// WEBPACK FOOTER //
// ./src/router.js